import CoreBase from '../../../services/engines/CoreBase';
import smartDeviceService from '../../../services/SmartDeviceService';

// Raw I/O + mapping of plug settings and sections, no caching/notify (Engine's job)
class PlugVueFetcher extends CoreBase {
    _name = 'PlugVueFetcher';

    /**
     * @returns {Promise<object[]>} static plug rows, live fields come from OnPlugStateChanged
     */
    fetch = async () => {
        try {
            const response = await smartDeviceService.getSettings();
            const items = response?.data?.items ?? [];
            return items.map(this._map);
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };

    /**
     * @returns {Promise<string[]>} section names in BE order
     */
    fetchSections = async () => {
        try {
            const response = await smartDeviceService.getSections();
            const items = response?.data?.items ?? [];
            return items.map((s) => s.name).filter(Boolean);
        } catch (error) {
            this.logError('fetchSections', error.message);
            return [];
        }
    };

    // settings ems renamed so it never collides with the live push ems
    _map = (item) => ({
        rk: item.rk,
        name: item.name,
        mac: item.mac,
        ip: item.ip,
        alias: item.alias || item.name,
        deviceClass: item.deviceClass,
        active: !!item.active,
        gname: item.gname ?? '',
        section: item.section || '',
        parentRk: item.parentRK || null,
        battery: item.battery ?? '',
        description: item.description ?? '',
        settingsEms: item.ems,
    });
}

const plugVueFetcher = new PlugVueFetcher();
export default plugVueFetcher;
